// Exchange-recap input schemas — Wave A return-hooks.
// One schema, two consumers: server validates via @hono/zod-validator;
// SPA validates via mantine-form-zod-resolver.

import { z } from 'zod';

import { idSchema, richTextSchema } from './common.js';

const RECAP_BODY_MAX = 2000;
const RECAP_TITLE_MAX = 120;
const RECAP_DECLINE_REASON_MAX = 500;
const RECAP_PHOTO_CAPTION_MAX = 200;

export const createOrUpdateRecapInputSchema = z.object({
  exchange_id: idSchema,
  body: richTextSchema(RECAP_BODY_MAX).default(''),
  title: richTextSchema(RECAP_TITLE_MAX).optional(),
});
export type CreateOrUpdateRecapInput = z.infer<typeof createOrUpdateRecapInputSchema>;

export const submitRecapInputSchema = z.object({
  exchange_id: idSchema,
});
export type SubmitRecapInput = z.infer<typeof submitRecapInputSchema>;

export const declineRecapInputSchema = z.object({
  exchange_id: idSchema,
  reason: richTextSchema(RECAP_DECLINE_REASON_MAX).refine(
    (s) => s.trim().length >= 5,
    { message: 'Leave a short note explaining what to revise.' },
  ),
});
export type DeclineRecapInput = z.infer<typeof declineRecapInputSchema>;

export const updateRecapPhotoInputSchema = z.object({
  caption: richTextSchema(RECAP_PHOTO_CAPTION_MAX).optional(),
  sort_order: z.number().int().min(0).max(100).optional(),
});
export type UpdateRecapPhotoInput = z.infer<typeof updateRecapPhotoInputSchema>;

export const RECAP_PHOTO_LIMITS = {
  maxPhotos: 6,
  maxBytesPerPhoto: 8 * 1024 * 1024,
  bodyMax: RECAP_BODY_MAX,
  titleMax: RECAP_TITLE_MAX,
} as const;
